import { useHospitalWards } from "../../../hooks/queries/admin/hospitalDetails";
import { useHospitals } from "../../../hooks/queries/admin/hospitals";
import { AdminSelectField, FilterLabel } from "../shared";
import { FilterField } from "./AdminPatients.styles";

interface IHospitalWardFilterProps {
  /** Prefix for the select ids, so two pages never share a label target. */
  idPrefix: string;
  hospitalId: string;
  wardId: string;
  /** Called with the new hospital; the caller clears the ward. */
  onHospitalChange: (hospitalId: string) => void;
  onWardChange: (wardId: string) => void;
}

/**
 * Hospital → ward filter for the patient lists (EN-5277), the same pair the
 * Cognito migration page uses. The ward list is the chosen hospital's, so the
 * ward select waits for a hospital.
 */
export function HospitalWardFilter({
  idPrefix,
  hospitalId,
  wardId,
  onHospitalChange,
  onWardChange,
}: IHospitalWardFilterProps) {
  const hospitalGroupId = hospitalId ? Number(hospitalId) : undefined;
  const { hospitals } = useHospitals();
  const { wards } = useHospitalWards(hospitalGroupId);

  return (
    <>
      <FilterField>
        <FilterLabel htmlFor={`${idPrefix}-hospital`}>Hospital</FilterLabel>
        <AdminSelectField
          id={`${idPrefix}-hospital`}
          value={hospitalId}
          onChange={(event) => onHospitalChange(event.target.value)}
        >
          <option value="">All hospitals</option>
          {hospitals.map((hospital) => (
            <option key={hospital.id} value={String(hospital.id)}>
              {hospital.name}
            </option>
          ))}
        </AdminSelectField>
      </FilterField>
      <FilterField>
        <FilterLabel htmlFor={`${idPrefix}-ward`}>Ward</FilterLabel>
        <AdminSelectField
          id={`${idPrefix}-ward`}
          value={wardId}
          disabled={!hospitalGroupId}
          onChange={(event) => onWardChange(event.target.value)}
        >
          <option value="">All wards</option>
          {wards.map((ward) => (
            <option key={ward.id} value={String(ward.id)}>
              {ward.name}
            </option>
          ))}
        </AdminSelectField>
      </FilterField>
    </>
  );
}
